import { render, staticRenderFns } from "./ItemBenefit.vue?vue&type=template&id=b62d5740&"
import script from "./ItemBenefit.vue?vue&type=script&lang=js&"
export * from "./ItemBenefit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports